import { useAuthContext } from "@/features/auth/hooks/use-auth-context";
import AuthedEventDetail from "@/features/events/screens/authed-event-detail";
import PublicEventDetail from "@/features/events/screens/public-event-detail";

/**
 * Event detail route entry. The page is partly public: logged-out visitors get
 * a read-only view whose engagement actions gate to login, while logged-in
 * users get the full join/leave experience. Both render the same
 * `EventDetailView`, so the layout can't drift between them.
 */
export default function EventDetailScreen() {
  const { isLoggedIn } = useAuthContext();
  return isLoggedIn ? <AuthedEventDetail /> : <PublicEventDetail />;
}
